<form [formGroup]="form">
  <div class="mt-4">
    <h3 i18n>Belegdrucker</h3>
    <hr />
    <div class="row mb-2">
      <div class="col-sm-6">
        <div class="row">
          <app-form-row label="Breite (cm)" i18n-label rowClass="row" labelClass="col-sm-6 col-form-label" fieldClass="col-sm-6">
            <input
              id="posPrinterPageWidth"
              data-testid="settings-printer-width"
              type="text"
              formControlName="posPrinterPageWidth"
              class="form-control form-control-sm"
              />
            <ng-template appFieldError="min"><span i18n>Die Seitenbreite muss zwischen 1 und 30 cm gesetzt sein</span></ng-template>
            <ng-template appFieldError="max"><span i18n>Die Seitenbreite muss zwischen 1 und 30 cm gesetzt sein</span></ng-template>
            <ng-template appFieldError="pattern"><span i18n>Die Seitenbreite muss einen ganzzahligen Wert zwischen 1 und 30 cm beinhalten</span></ng-template>
          </app-form-row>
        </div>
        <p class="form-text" i18n>Die Länge eines Belegs richtet sich nach der Anzahl seiner Positionen.</p>
      </div>
      <div class="col-sm-6">
        <app-order-receipt [order]="sample" [widthCm]="previewWidthCm" watermark="test"></app-order-receipt>
        <button
          class="btn btn-secondary mt-2"
          type="button"
          data-testid="settings-printer-test-print"
          [disabled]="form.controls.posPrinterPageWidth.invalid"
          (click)="onTestPrint()"
          i18n
          >
          Testseite drucken
        </button>
      </div>
    </div>
  </div>

  <div class="mt-4">
    @if (profile?.isActive) {
      <button
        class="btn btn-primary m-2"
        type="button"
        data-testid="settings-printer-save"
        [asyncClick]="save.bind(this)"
        [disabled]="saveBtn.disabled || form.pristine || form.invalid"
        #saveBtn="asyncClick"
        i18n
        >
        @if (saveBtn.busy) { <span class="spinner-border spinner-border-sm me-1"></span> }
        Einstellungen speichern
      </button>
    }
  </div>
</form>
